import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import HistoryTableComp from "./Component/HistoryTableComp"


const ManagerHistoryTable =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <HistoryTableComp />
            
        </div>
        <Footer />
        </>
    )
}

export default ManagerHistoryTable